import { useState, useEffect } from 'react';
import axios from 'axios';
import { API, auth } from '../pages/organization/finance/shared';

let cache = null;
export function useClubIdentity() {
  const [identity, setIdentity] = useState(cache);
  useEffect(() => {
    if (cache) { setIdentity(cache); return; }
    axios.get(`${API}/club-settings`, auth()).then((r) => { cache = r.data; setIdentity(r.data); }).catch(() => {});
  }, []);
  return identity;
}
